/**
 * SegmentListItem - Individual segment item in the segment list
 *
 * Displays segment information (ID, modules, capacity, azimuth) with selection and delete actions.
 */

import React from 'react';

interface SegmentListItemProps {
  segmentId: number;
  polygonId: number;
  moduleCount: number;
  capacityKw: string;
  azimuth: number;
  isSelected: boolean;
  isFreeField: boolean;
  onSelect: () => void;
  onDelete: () => void;
}

export function SegmentListItem({
  segmentId,
  polygonId,
  moduleCount,
  capacityKw,
  azimuth,
  isSelected,
  isFreeField,
  onSelect,
  onDelete,
}: SegmentListItemProps) {
  return (
    <div
      onClick={onSelect}
      className={`p-2 rounded cursor-pointer transition-colors ${
        isSelected
          ? 'bg-green-100 border-2 border-green-500'
          : isFreeField
            ? 'bg-cyan-50 border border-cyan-200 hover:bg-cyan-100'
            : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
      }`}
    >
      <div className="flex justify-between items-center">
        <div>
          <span className={`font-semibold text-xs ${isFreeField ? 'text-cyan-800' : 'text-gray-800'}`}>
            {isFreeField ? 'Free-Field' : `Roof ${polygonId}`} #{segmentId}
          </span>
          <div className="text-xs text-gray-500">
            {moduleCount} modules • {capacityKw} kW • {azimuth}°
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          className="text-red-500 hover:text-red-700 text-xs font-semibold px-1"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default SegmentListItem;
